import { rankingExibido, superficieDaPosicao } from "./keyword-link";

type PosicaoSource = {
  currentRanking?: number | null;
  serpRanking?: number | null;
};

const ONDE = {
  pesquisa: "na Pesquisa",
  maps: "no Maps",
} as const;

/**
 * Texto do balão de posição. Diz SEMPRE em qual Google o cliente está naquele
 * lugar: a posição na Pesquisa e a do Maps divergem bastante (Pitigliano #1 na
 * Pesquisa e #3 no Maps), e sem dizer de onde veio o número o relatório engana.
 */
export const textoDaPosicao = (keyword: PosicaoSource, mobile = false): string => {
  const posicao = rankingExibido(keyword);
  if (posicao < 1 || posicao > 3) {
    return mobile ? "Ranqueando" : "Consolidando ranqueamento";
  }
  const onde = ONDE[superficieDaPosicao(keyword)];
  return mobile ? `${posicao}º ${onde}` : `${posicao}º lugar ${onde}`;
};

/** Nome curto da fonte do número, para tabela: "Pesquisa" ou "Maps". */
export const nomeDaSuperficie = (keyword: PosicaoSource): string =>
  superficieDaPosicao(keyword) === "pesquisa" ? "Pesquisa" : "Maps";

/**
 * Linha de apoio com a posição no Maps, para o cliente ver as duas medidas.
 * Só aparece quando o número principal é o da Pesquisa — repetir "Maps" duas
 * vezes na mesma linha confunde. Maps 0 = fora da lista, não é posição.
 */
export const textoDoMaps = (keyword: PosicaoSource): string | null => {
  if (superficieDaPosicao(keyword) !== "pesquisa") {
    return null;
  }
  const posicaoNoMaps = keyword.currentRanking ?? 0;
  return posicaoNoMaps >= 1 ? `No Maps: ${posicaoNoMaps}º` : null;
};
